"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockFinancialDocumentsDownloadTask = void 0;
const common_1 = require("@hum/common");
const types_1 = require("@hum/types");
const faker_1 = require("@faker-js/faker");
const createMockFinancialDocumentsDownloadTask = (overwrites = {}) => (Object.assign({ state: (0, common_1.randomlySelectObjectValue)(types_1.FinancialDocumentTaskStates), fileUrl: faker_1.faker.internet.url() }, overwrites));
exports.createMockFinancialDocumentsDownloadTask = createMockFinancialDocumentsDownloadTask;
//# sourceMappingURL=FinancialDocuments.factory.js.map